import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/user/applications")({
  staticData: { application: "Admin" },
});
